import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/user.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-settings-view',
  templateUrl: './settings-view.component.html',
  styleUrls: ['./settings-view.component.scss'],
  standalone: false
})
export class SettingsViewComponent {

  user?: User;

  userOptionsList: any = [
    {
      iconLeft: 'user',
      text: 'Dein Profil',
      iconRight: 'chevron-right',
      action: 'edit-profile'
    },
  ];

  otherOptionsList: any = [
    {
      iconLeft: 'diamond',
      text: 'Premium-Upgrade',
      iconRight: 'chevron-right',
      action: 'get-premium'
    },
    {
      iconLeft: 'messages',
      text: 'Kontaktiere uns',
      iconRight: 'chevron-right',
      action: 'contact'
    },
    {
      iconLeft: 'shield',
      text: 'Datenschutzerklärung',
      iconRight: 'chevron-right',
      action: 'privacy-policy'
    },
  ];

  logoutList: any = [
    {
      iconLeft: 'logout',
      text: 'Abmelden',
      action: 'logout',
      color: 'warn'
    },
  ];

  showEditProfile: boolean = false;

  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.getUser().subscribe(user => {
      this.user = user;
      if (this.user?.isPremiumUser) {
        this.otherOptionsList.find((item: any) => item.action === 'get-premium').text = 'Abo verwalten';
        this.otherOptionsList.find((item: any) => item.action === 'get-premium').action = 'abo-settings';
      }
    });
  }

  handleItemClick(item: any) {
    if (item.action === 'edit-profile') {
      this.showEditProfile = true;
    }
    if (item.action === 'get-premium') {
      this.router.navigate(['get-premium']);
    }
    if (item.action === 'abo-settings') {
      this.router.navigate(['settings/subscription']);
    }
    if (item.action === 'contact') {
      this.router.navigate(['contact']);
    }
    if (item.action === 'privacy-policy') {
      this.router.navigate(['privacy-policy']);
    }
    if (item.action === 'logout') {
      this.userService.logout();
    }
  }
}
